import React from 'react';
import { Portfolio, PortfolioItem } from 'components/digitalNomad/LatestWork.style.js';

import rushmoorPark from 'assets/digitalNomad/web-development/rushmoor-park.png';
import experianMbp from 'assets/digitalNomad/web-development/experian-mbp.png';
import reelFlyFishing from 'assets/digitalNomad/web-development/reelflyfishing.png';
import sankey from 'assets/digitalNomad/web-development/sankey.png';
import wop from 'assets/digitalNomad/web-development/wop.png';
import wopMap from 'assets/digitalNomad/web-development/wop-map.png';
import geekCalculator from 'assets/digitalNomad/web-development/geek-calculator.png';
import ezCoder from 'assets/digitalNomad/web-development/ez-coder.png';

const LatestWork = (props) => {
  return (
    <Portfolio>
      <PortfolioItem>
        <figure>
          <img src={rushmoorPark} alt="" />
          <figcaption>
            <h3>Rushmoor Country Farm Park</h3>
            <p>Full web design and development from the ground up, for family friendly country farm park.</p>
          </figcaption>
        </figure>
      </PortfolioItem>
      <PortfolioItem>
        <figure>
          <img src={experianMbp} alt="" />
          <figcaption>
            <h3>Experian My Business Profile</h3>
            <p>Development for the experian my business profile platform servicng thousands of business customers.</p>
          </figcaption>
        </figure>
      </PortfolioItem>
      <PortfolioItem>
        <figure>
          <img src={reelFlyFishing} alt="" />
          <figcaption>
            <h3>Reel Fly Fishing</h3>
            <p>Creative portfolio showcase website design and development for professional fly fishing instructor Andy Smith.</p>
          </figcaption>
        </figure>
      </PortfolioItem>
      <PortfolioItem>
        <figure>
          <img src={sankey} alt="" />
          <figcaption>
            <h3>John Sankey</h3>
            <p>Development and Programming on&nbsp;bespoke product customiser for luxury crafted sofas, chairs and furniture.</p>
          </figcaption>
        </figure>
      </PortfolioItem>
      <PortfolioItem>
        <figure>
          <img src={wop} alt="" />
          <figcaption>
            <h3>World of Ports</h3>
            <p>Responsive website build to target multiple devices.</p>
          </figcaption>
        </figure>
      </PortfolioItem>
      <PortfolioItem>
        <figure>
          <img src={wopMap} alt="" />
        <figcaption>
          <h3>World of Ports</h3>
          <p>Development and Programming for unique Google map integration, with distinctive searching capabilities.</p>
        </figcaption>
        </figure>
      </PortfolioItem>
      <PortfolioItem>
        <figure>
          <img src={geekCalculator} alt="" />
        <figcaption>
          <h3>Newsworks</h3>
          <p>Programming for immensely popular geek calculator quiz development, featured in the Daily Mail and Telegraph.</p>
        </figcaption>
        </figure>
      </PortfolioItem>
      <PortfolioItem>
        <figure>
          <img src={ezCoder} alt="" />
        <figcaption>
          <h3>Ezcoder</h3>
          <p>Responsive web based social code editor/IDE, as developed for university dissertation.</p>
        </figcaption>
        </figure>
      </PortfolioItem>
    </Portfolio>
  );
};

export default LatestWork;



// WEBPACK FOOTER //
// ./src/components/digitalNomad/LatestWork.js